import React from "react";

const UploadFileIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.43153 7.18925H8.58512V13.5779C8.58512 14.2261 9.11067 14.751 9.75819 14.751H12.9602C13.6076 14.751 14.1332 14.2261 14.1332 13.5779V7.18925H16.2861C16.6427 7.18925 16.9633 6.97451 17.1005 6.64492C17.2362 6.31667 17.1607 5.9372 16.9087 5.68521L11.9817 0.757568C11.6375 0.414144 11.0801 0.414144 10.7352 0.757568L5.80899 5.68521C5.55696 5.9372 5.48144 6.31603 5.61789 6.64492C5.75495 6.97386 6.07487 7.18925 6.43153 7.18925Z" fill="currentColor" />
      <path d="M20.9409 9.58398C20.3571 9.58398 19.8835 10.0577 19.8835 10.6421V15.0663C19.8835 16.3916 18.8046 17.4698 17.4792 17.4698H5.23847C3.91308 17.4698 2.83491 16.3916 2.83491 15.0663V10.6421C2.83491 10.0577 2.36059 9.58398 1.77683 9.58398C1.19238 9.58398 0.71875 10.0577 0.71875 10.6421V15.0663C0.71875 17.5584 2.74626 19.586 5.23847 19.586H17.4792C19.9714 19.586 21.999 17.5585 21.999 15.0663V10.6421C21.999 10.0577 21.5253 9.58398 20.9409 9.58398Z" fill="currentColor" />
    </svg>
  );
};

export default UploadFileIcon;


